require("select2/dist/css/select2.min.css");
require("select2");

// Proxies to the upstream API server-side (core/vaad_form/vaad_form.php:
// iomv_vaad_form_rest_submit) — same CORS/API-key reasoning as
// LOCATIONS_REFRESH_ENDPOINT below.
const VAAD_FORM_ENDPOINT = "/wp-json/iomv-theme/v1/vaad-form";

// The upstream locations API doesn't send Access-Control-Allow-Origin, so a
// direct browser fetch() to it hits CORS — and would also leak the API key
// into the public JS bundle. This calls our own origin instead; the server
// does the real GET (core/locations/locations.php: iomv_locations_refresh).
const LOCATIONS_REFRESH_ENDPOINT = "/wp-json/iomv-theme/v1/locations/refresh";

function fetchLocations() {
    return fetch(LOCATIONS_REFRESH_ENDPOINT, {
        method: "POST",
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Refresh request failed with status " + response.status);
            }

            return response.json();
        });
}

// A backend can link straight to a vaad with the form pre-filled by base64-
// encoding a JSON object (full_name, phone_code, phone, email, country,
// state, city) into ?iomv_prefill= — carried through by the plugin's
// ?iomv_vaad_ref= redirect (see IOMV_Vaad_Redirect::PREFILL_PARAM). Decoded
// via the standard atob → percent-escape → decodeURIComponent dance so
// non-ASCII names survive intact, not just plain atob() (which mangles
// anything outside Latin-1).
function decodeBase64Json(value) {
    try {
        const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
        const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
        const binary = window.atob(padded);
        const percentEncoded = binary
            .split("")
            .map((char) => "%" + char.charCodeAt(0).toString(16).padStart(2, "0"))
            .join("");

        return JSON.parse(decodeURIComponent(percentEncoded));
    } catch (error) {
        return null;
    }
}

function readPrefillFromUrl() {
    const encoded = new URLSearchParams(window.location.search).get("iomv_prefill");
    return encoded ? decodeBase64Json(encoded) : null;
}

(function ($) {

    // Selects (or creates, tags-style) the matching <option> and updates
    // select2's visual state. Shared by the plain phone-code select and the
    // chained country/state/city ones.
    function setSelect2Value($select, value) {
        if (!value) {
            return;
        }

        const exists = $select.find("option").filter(function () {
            return this.value === value;
        }).length > 0;

        if (!exists) {
            $select.append(new Option(value, value, false, false));
        }

        $select.val(value).trigger("change");
    }

    // Country -> State -> City chained selects (select2.org "Chained Selects"
    // pattern): each level is a plain select2 with its options replaced
    // whenever the level above it changes. "tags: true" on all three lets a
    // visitor type a value that isn't in the locations.json dataset.
    //
    // prefill.state/prefill.city (if any) are stashed as "pending" and
    // consumed by the country/state change handlers below once their own
    // fetch resolves — that's the same async cascade a visitor triggers by
    // hand, just kicked off programmatically instead of by a click.
    function initLocationSelects($form, prefill) {
        const $country = $form.find(".js-country-select");
        const $state = $form.find(".js-state-select");
        const $city = $form.find(".js-city-select");
        const config = window.IOMV_VAAD_FORM || {};
        const vaadId = $form.find("[name=\"vaad_id\"]").val();
        let pendingState = prefill ? prefill.state : null;
        let pendingCity = prefill ? prefill.city : null;

        if (!$country.length || !$state.length || !$city.length || typeof $.fn.select2 !== "function") {
            return;
        }

        if (!config.countriesEndpoint || !config.statesEndpoint || !config.citiesByStateEndpoint) {
            return;
        }

        function initSelect($select) {
            $select.select2({
                width: "100%",
                placeholder: $select.data("placeholder") || "",
                allowClear: true,
                tags: true,
            });
        }

        function fillOptions($select, items) {
            $select.empty().append(new Option("", "", false, false));

            items.forEach((item) => {
                $select.append(new Option(item.text, item.id, false, false));
            });

            $select.val(null).trigger("change");
        }

        initSelect($country);
        initSelect($state);
        initSelect($city);

        $state.prop("disabled", true);
        $city.prop("disabled", true);

        $.getJSON(config.countriesEndpoint)
            .done((data) => {
                fillOptions($country, data.results || []);

                if (prefill && prefill.country) {
                    // Triggers this same $country "change" handler below,
                    // which fetches states and, once that resolves, applies
                    // pendingState — continuing the cascade down to city.
                    setSelect2Value($country, prefill.country);
                }
            });

        // State/city stay disabled until their fetch actually resolves with
        // options — enabling an empty dropdown just to open onto nothing is
        // worse than leaving it inactive.
        $country.on("change", function () {
            const country = $country.val();

            fillOptions($state, []);
            $state.prop("disabled", true);

            if (!country) {
                return;
            }

            $.getJSON(config.statesEndpoint, { country, vaad_id: vaadId })
                .done((data) => {
                    const results = data.results || [];
                    fillOptions($state, results);
                    $state.prop("disabled", results.length === 0);

                    if (pendingState) {
                        const state = pendingState;
                        pendingState = null;
                        // Triggers $state's own "change" handler below,
                        // which fetches cities and applies pendingCity.
                        setSelect2Value($state, state);
                    }
                });
        });

        $state.on("change", function () {
            const country = $country.val();
            const state = $state.val();

            fillOptions($city, []);
            $city.prop("disabled", true);

            if (!country || !state) {
                return;
            }

            $.getJSON(config.citiesByStateEndpoint, { country, state, vaad_id: vaadId })
                .done((data) => {
                    const results = data.results || [];
                    fillOptions($city, results);
                    $city.prop("disabled", results.length === 0);

                    if (pendingCity) {
                        const city = pendingCity;
                        pendingCity = null;
                        setSelect2Value($city, city);
                    }
                });
        });
    }

    function initPhoneCodeSelect2($form, prefill) {
        const $phoneCode = $form.find(".js-phone-code-select");

        if (!$phoneCode.length || typeof $.fn.select2 !== "function") {
            return;
        }

        $phoneCode.select2({
            width: "resolve",
            minimumResultsForSearch: Infinity,
        });

        if (prefill && prefill.phone_code) {
            setSelect2Value($phoneCode, prefill.phone_code);
        }
    }

    function applyTextPrefill($form, prefill) {
        if (!prefill) {
            return;
        }

        if (prefill.full_name) {
            $form.find("[name=\"full_name\"]").val(prefill.full_name);
        }

        if (prefill.phone) {
            $form.find("[name=\"phone\"]").val(prefill.phone);
        }

        if (prefill.email) {
            $form.find("[name=\"email\"]").val(prefill.email);
        }
    }

    function buildPayload($form, formType) {
        const payload = {
            vaad_id: ($form.find("[name=\"vaad_id\"]").val() || "").trim(),
            form_type: formType,
            full_name: $form.find("[name=\"full_name\"]").val().trim(),
            phone_code: $form.find("[name=\"phone_code\"]").val(),
            phone: $form.find("[name=\"phone\"]").val().trim(),
            email: $form.find("[name=\"email\"]").val().trim(),
            country: ($form.find("[name=\"country\"]").val() || "").trim(),
            state: ($form.find("[name=\"state\"]").val() || "").trim(),
            city: ($form.find("[name=\"city\"]").val() || "").trim(),
            question_title: $form.find("[name=\"question_title\"]").val().trim(),
            question: $form.find("[name=\"question\"]").val().trim(),
        };

        if (formType === "confirm") {
            payload.meeting_times = $form.find(".time-box").map(function () {
                const $box = $(this);

                return {
                    time: $box.data("time"),
                    answer: $box.find("input[type=\"radio\"]:checked").val() || null,
                };
            }).get();

            payload.coordinate = $form.find("[name=\"coordinate\"]:checked").val() || null;
            payload.watched_intro = $form.find("[name=\"watched_intro\"]").is(":checked");
            payload.read_information = $form.find("[name=\"read_information\"]").is(":checked");
        } else {
            payload.read_details = $form.find("[name=\"read_details\"]").is(":checked");
        }

        return payload;
    }

    function setStatus($form, message, isError) {
        $form.find(".form-status")
            .text(message)
            .toggleClass("is-error", !!isError)
            .toggleClass("is-success", !isError && !!message);
    }

    // Backstop for the phone input's HTML "pattern" attribute: Chromium
    // doesn't reliably enforce patternMismatch on type="tel" fields, so a
    // value like "abc" can pass native constraint validation unnoticed.
    function isPhoneValid(value) {
        const digits = value.replace(/\D/g, "");
        return digits.length >= 6 && digits.length <= 15 && /^[0-9+\s().-]+$/.test(value);
    }

    // Swallows the rejection (nothing to show the visitor for a background
    // refresh) rather than leaving it uncaught — a bare fetch().catch()-less
    // chain would otherwise surface as an unhandled promise rejection.
    fetchLocations().catch(() => {});

    const prefill = readPrefillFromUrl();

    $(".custom-vaad-form").each(function () {
        const $form = $(this);

        applyTextPrefill($form, prefill);
        initLocationSelects($form, prefill);
        initPhoneCodeSelect2($form, prefill);
    });

    $(".custom-vaad-form").on("submit", function (e) {
        e.preventDefault();

        const $form = $(this);
        const formType = $form.data("form-type");
        const $submit = $form.find(".form-submit");
        const $phone = $form.find("[name=\"phone\"]");

        if (!isPhoneValid($phone.val())) {
            setStatus($form, "Please enter a valid phone number.", true);
            $phone.trigger("focus");
            return;
        }

        const payload = buildPayload($form, formType);

        $submit.prop("disabled", true);
        setStatus($form, "", false);

        fetch(VAAD_FORM_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Request failed with status " + response.status);
                }

                return response.json();
            })
            .then(() => {
                setStatus($form, "Thank you! Your submission has been received.", false);
                $form[0].reset();
            })
            .catch(() => {
                setStatus($form, "Something went wrong. Please try again later.", true);
            })
            .finally(() => {
                $submit.prop("disabled", false);
            });
    });

})(jQuery);
